import '.am{position:relative;}.ssr-plugin'
import '.j5{width:64px;}.ssr-plugin'
import '.j6{height:64px;}.ssr-plugin'
import '.ag{flex-shrink:0;}.ssr-plugin'
import '.bv{position:absolute;}.ssr-plugin'
import '.j7{bottom:-4px;}.ssr-plugin'
import '.hx{right:-4px;}.ssr-plugin'
import '.fp{border-radius:50%;}.ssr-plugin'
import '.j8{border:2px solid var(--palette-white);}.ssr-plugin'
import '.at{overflow:hidden;}.ssr-plugin'
import '.j9{width:32px;}.ssr-plugin'
import '.ja{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="am j5 j6 ag"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bv j7 hx fp j8 at j9 ja"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
